import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { api } from './services/api';
import globalDataSlicer from './features/globalData';
import authSlicer from './features/auth';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import scheduleSlicer from './features/schedule';
import pagesSlicer from './features/pages';
const persistConfig = {
    key: 'root',
    version: 1,
    storage,
    whitelist: [
        'authSlicer',
        'globalDataSlicer',
        'scheduleSlicer',
        'pagesSlicer',
    ],
};
const reducers = combineReducers({
    globalDataSlicer: globalDataSlicer,
    authSlicer: authSlicer,
    scheduleSlicer: scheduleSlicer,
    pagesSlicer: pagesSlicer,
    api: api.reducer,
});
const persistedReducer = persistReducer(persistConfig, reducers);
export const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false }).concat(api.middleware),
});
